// eslint-disable-next-line
import util from "util";

import React, { Component } from "react";
import { connect } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
// eslint-disable-next-line
import * as MuiCore from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as accountActions from "account/actions";
import * as coreSelectors from "core/selectors";
import * as serviceSelectors from "service/selectors";
import * as serviceActions from "service/actions";
import * as accountSelectors from "account/selectors";
import DataTable from "ui/DataTable";
import OverlayLoader from "ui/OverlayLoader";
import { canAccessBlockedContacts } from "utils";
import { USER_ACCOUNT_ROLE_KEYS } from "constants/account.roles.constants";
import SearchInput from "ui/SearchInput";
import AccountSelectContainer from "ui/AccountSelectContainer";
import { columns } from "./blockNumbers.columns";
import BlockNumberActions from "./BlockNumberActions";
import BlockNumberForm from "./BlockNumberForm";

const styles = (theme) => ({
  /* Display the formated number with country flag */
  formClass: {
    width: "auto !important",
  },

  /* Top control area with search box and add content */
  controlPanel: {
    display: "flex",
    alignItems: "center",
  },
  accountSelection: {
    width: "100%",
    padding: 20,
    border: "1px solid #CCCDD2",
  },
  title: {
    ...theme.typography.h6,
    margin: 0,
    paddingLeft: 20,
    paddingRight: 20,
    fontFamily: "Sofia-bold",
  },
});

class BlockNumbers extends Component {
  state = {
    // number list
    filterSearch: "",
    filteredResults: [],
    isLoading: false,
    // Upsert Form
    showAddPopup: false,
    updateFormState: {},
  };

  startBlockNumber = () => {
    this.setState({ showAddPopup: true });
  };
  updateBlockNumber = (entryId, phoneNumber, company, name) => {
    this.setState({
      showAddPopup: true,
      updateFormState: {
        updateEntryId: entryId,
        phoneNumber: phoneNumber,
        company,
        name,
      },
    });
  };
  closeForm() {
    this.setState({
      showAddPopup: false,
      updateFormState: {},
    });
  }

  getRestrictedRoles() {
    return [USER_ACCOUNT_ROLE_KEYS.GUEST, USER_ACCOUNT_ROLE_KEYS.INACTIVE];
  }
  getFilteredAccounts() {
    return (this.props.user.userAccountRoles || []).filter(
      (role) => !this.getRestrictedRoles().includes(role.userRoleKey)
    );
  }
  componentDidMount() {
    var accounts = this.getFilteredAccounts();

    if (this.props.accountId !== "") {
      this.setState({ isLoading: true });
      this.props.queryAccount();
      this.props.getBlockNumbersByAccount(this.props.accountId, () =>
        this.setState({ isLoading: false })
      );
    } else if (accounts.length > 0 && this.props.accountId === "") {
      this.setState({ isLoading: true });
      this.props.setAccountId(accounts[0].accountId);
      this.props.getBlockNumbersByAccount(accounts[0].accountId, () =>
        this.setState({
          isLoading: false,
          filteredResults: this.props.blockNumberList,
        })
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.accountId !== this.props.accountId) {
      this.setState({ isLoading: true });
      this.props.queryAccount();
      this.props.getBlockNumbersByAccount(this.props.accountId, () =>
        this.setState({
          isLoading: false,
          filteredResults: this.props.blockNumberList,
        })
      );
    }
    if (prevProps.blockNumberList !== this.props.blockNumberList) {
      this.setState({ filteredResults: this.props.blockNumberList });
      if (this.state.filterSearch.length) {
        this.changeFilterSearch(this.state.filterSearch);
      }
    }
  }
  changeFilterSearch(filterSearch) {
    this.setState({ filterSearch });
    const filteredResults = this.props.blockNumberList.filter(
      (contact) =>
        contact?.phoneNumber
          ?.toLowerCase()
          ?.includes(filterSearch.toLowerCase()) ||
        contact?.name?.toLowerCase()?.includes(filterSearch.toLowerCase()) ||
        contact?.company?.toLowerCase()?.includes(filterSearch.toLowerCase())
    );
    this.setState({ filteredResults });
  }
  render() {
    const { classes, blockNumberList, user } = this.props;
    if (this.state.isLoading) {
      return <OverlayLoader />;
    }
    if (!canAccessBlockedContacts(user)) {
      return (
        <MuiCore.Typography
          style={{
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Sofia",
            fontWeight: 600,
          }}
        >
          You do not have access to view this page.
        </MuiCore.Typography>
      );
    }
    var distinctAccounts = [];
    var accounts = (this.props.user.userAccountRoles || []).filter(
      (role, index, arr) => {
        if (
          !this.getRestrictedRoles().includes(role.userRoleKey) &&
          distinctAccounts.indexOf(role.accountId) === -1
        ) {
          distinctAccounts.push(role.accountId);
          return true;
        } else {
          return false;
        }
      }
    );

    return (
      <div>
        <BlockNumberForm
          open={this.state.showAddPopup}
          formState={this.state.updateFormState}
          close={() => this.closeForm()}
        />
        <MuiCore.Grid
          container
          direction="column"
          wrap="nowrap"
          style={{ height: "100%", paddingLeft: 20 }}
          alignItems="stretch"
        >
          <MuiCore.Grid item lg={12} md={12}>
            <MuiCore.Grid lg={6} style={{ alignSelf: "center" }}>
              <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                <AccountSelectContainer>
                  <MuiCore.Select
                    className={classes.dropdown}
                    labelId="demo-simple-select-label"
                    onChange={(event) => {
                      this.props.setAccountId(event.target.value);
                    }}
                    value={this.props.accountId}
                  >
                    {accounts.map((account) => (
                      <MuiCore.MenuItem
                        key={account.accountId}
                        value={account.accountId}
                      >
                        {account.accountNumber} {account.accountName}
                      </MuiCore.MenuItem>
                    ))}
                  </MuiCore.Select>
                </AccountSelectContainer>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <MuiCore.Grid
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            style={{ marginBottom: 10, marginTop: 10 }}
          >
            <div className={classes.controlPanel}>
              {!!blockNumberList.length && (
                <SearchInput
                  value={this.state.filterSearch}
                  onChange={(event) =>
                    this.changeFilterSearch(event.target.value)
                  }
                  onCloseIconClick={() => this.changeFilterSearch("")}
                />
              )}
              <MuiCore.IconButton onClick={this.startBlockNumber}>
                <AddIcon fontSize="large" />
              </MuiCore.IconButton>
            </div>
          </MuiCore.Grid>
          <MuiCore.Grid item xs={12}>
            <div style={{ display: "block" }}>
              <DataTable
                onRowClick={(contact) => {
                  this.updateBlockNumber(
                    contact?.entryId,
                    contact?.phoneNumber,
                    contact?.company ?? "",
                    contact?.name ?? ""
                  );
                }}
                columns={[
                  ...columns,
                  {
                    heading: "",
                    renderCell: (contact) => {
                      return (
                        <BlockNumberActions
                          contact={contact}
                          updateBlockNumber={(
                            entryId,
                            phoneNumber,
                            company,
                            name
                          ) => {
                            this.updateBlockNumber(
                              entryId,
                              phoneNumber,
                              company,
                              name
                            );
                          }}
                        />
                      );
                    },
                  },
                ]}
                data={this.state.filteredResults}
                getRowId={(row) => row.entryId}
                enableNoContentPlaceholder
                marginTop={5}
                paginate
              />
            </div>
          </MuiCore.Grid>
        </MuiCore.Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accountId: accountSelectors.getAccountId(state),
    user: coreSelectors.getUser(state),
    blockNumberList: serviceSelectors.getBlockNumbersByAccount(state),
  };
};

const mapDispatchToProps = {
  setAccountId: accountActions.setAccountId,
  queryAccount: accountActions.queryAccount,
  getBlockNumbersByAccount: serviceActions.blockNumbersByAccount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(BlockNumbers));
